<script lang="ts">
    import { networkStore } from "../../../../../store/networks";

    $: currentPage = $networkStore.networks.page + 1;
    $: previousPage = $networkStore.networks.page;
    $: nextPage = $networkStore.networks.page + 2;
    $: lastPage =
        $networkStore.networks.totalElements % $networkStore.networks.size === 0
            ? $networkStore.networks.totalElements / $networkStore.networks.size
            : Math.ceil(
                  $networkStore.networks.totalElements /
                      $networkStore.networks.size
              );
</script>

<!-- svelte-ignore a11y-missing-attribute -->
<div class="column is-10 is-offset-1">
    <nav
        class="pagination is-centered is-rounded"
        role="navigation"
        aria-label="pagination"
    >
        <a
            class="pagination-previous gradient-left"
            on:click={() => networkStore.getPrevPage($networkStore)}
            >Vorherige</a
        >
        <a
            class="pagination-next gradient-left"
            on:click={() => networkStore.getNextPage($networkStore)}>Weiter</a
        >
        <ul class="pagination-list">
            {#if currentPage > 1}
                {#if currentPage > 2}
                    <li>
                        <a
                            class="pagination-link"
                            on:click={() =>
                                networkStore.getFirstPage($networkStore)}>1</a
                        >
                    </li>
                    {#if currentPage > 3}
                        <li>
                            <span class="pagination-ellipsis">&hellip;</span>
                        </li>
                    {/if}
                {/if}
                <li>
                    <a
                        class="pagination-link"
                        on:click={() => networkStore.getPrevPage($networkStore)}
                        >{previousPage}</a
                    >
                </li>
            {/if}
            <li>
                <a class="pagination-link is-current gradient-left"
                    >{currentPage}</a
                >
            </li>
            {#if currentPage < lastPage}
                <li>
                    <a
                        class="pagination-link"
                        aria-label="Goto page 47"
                        on:click={() => {
                            networkStore.getPageNumbered(
                                $networkStore,
                                nextPage - 1
                            );
                        }}>{nextPage}</a
                    >
                </li>
                {#if currentPage < lastPage - 1}
                    {#if currentPage < lastPage - 2}
                        <li>
                            <span class="pagination-ellipsis">&hellip;</span>
                        </li>
                    {/if}
                    <li>
                        <a
                            class="pagination-link"
                            aria-label="Goto page 86"
                            on:click={() =>
                                networkStore.getLastPage($networkStore)}
                            >{lastPage}</a
                        >
                    </li>
                {/if}
            {/if}
        </ul>
    </nav>
</div>
